// extracted by mini-css-extract-plugin
export default {"goTopHidden":"GoTopButton_goTopHidden__X9O4-","slide-down":"GoTopButton_slide-down__K5b2X","goTop":"GoTopButton_goTop__YBQBT","slide-top":"GoTopButton_slide-top__5KEx9"};